import { Button, Drawer, Flex } from 'antd';
import STTypo from 'core/shared/typo';
import { TypeOptions } from 'core/shared/typo/typo.models';
import { useTranslation } from 'react-i18next';

type ReportDrawerUnavailableProps = {
  closeDrawer?: () => void;
  callbackDrawer?: () => void;
  onClose?: () => void;
};

// Stands in for any report-drawer chunk that failed to load; reload is the only real
// recovery since React caches the rejection for the session. Accepts whichever close
// prop name the replaced drawer used, falling back to a no-op so it's never stuck open.
export const ReportDrawerUnavailable = ({ closeDrawer, callbackDrawer, onClose }: ReportDrawerUnavailableProps) => {
  const [t] = useTranslation();
  const handleClose = closeDrawer ?? callbackDrawer ?? onClose ?? (() => undefined);

  return (
    <Drawer
      open
      size={480}
      className='st-report-drawer'
      data-testid='st-report-drawer-unavailable'
      placement='right'
      title={
        <div className='st-report-drawer'>
          <STTypo type={TypeOptions.H4}>{t('report.title.header')}</STTypo>
        </div>
      }
      onClose={handleClose}
      maskClosable>
      <Flex vertical gap={16} align='flex-start'>
        <STTypo type={TypeOptions.P1}>{t('modals.update.description')}</STTypo>
        <Button type='primary' onClick={() => globalThis.location.reload()}>
          {t('modals.update.button')}
        </Button>
      </Flex>
    </Drawer>
  );
};

export default ReportDrawerUnavailable;
